var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JadeBox", { attrs: { hasPadding: "" } }, [
        _c("div", { staticClass: "validation__img--container" }, [
          _c("img", {
            attrs: { src: require(`@/assets/kyc/step_1.svg`).default },
          }),
        ]),
        _c(
          "div",
          { staticClass: "validation__text--container" },
          [
            _c(
              "jade-text",
              { attrs: { weight: "bold", variant: "heading-small" } },
              [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
            ),
            _c("jade-text", { attrs: { variant: "text-medium" } }, [
              _vm._v(" " + _vm._s(_vm.$t("subtitle")) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "validation__date--container" },
          [
            _c("jade-icon", {
              attrs: { use: "action-refresh", size: "medium", color: "brand" },
            }),
            _c(
              "jade-text",
              { attrs: { variant: "text-medium", color: "brand" } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("updated_at", { date: _vm.date, time: _vm.time })
                    ) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }